import { useState, useEffect } from "react"

export const useDisplayIcon = () => {
  const [displayIcon, setDisplayIcon] = useState(false)
  useEffect(() => {
    setDisplayIcon(true)
  }, [])

  return displayIcon ? "inline-block" : "none"
}
